import { useTranslation } from 'react-i18next';
import { EmptyState } from '@platform/ui';
import type { ICustomViewPlaceholderProps } from './ICustomViewPlaceholderProps';

/** Заглушка для власних подань (hall, cmatrix, riskmatrix…), поки пакет модуля не зареєстрував компонент у viewRegistry. */
export function CustomViewPlaceholder({ model, name }: ICustomViewPlaceholderProps) {
  const { t } = useTranslation();
  return <EmptyState text={t('views.custom', { name: name ?? model?.state.view ?? '' })} />;
}
